import { render, staticRenderFns } from "./user-report.vue?vue&type=template&id=bc5347da&"
import script from "./user-report.vue?vue&type=script&lang=ts&"
export * from "./user-report.vue?vue&type=script&lang=ts&"
import style0 from "./user-report.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports